import React, { useState } from 'react';
import { Box, Button, Grid, Paper, TextField, Typography, CircularProgress } from '@mui/material';
import img from "../images/serviceimg/serviceImg.svg";
import constructionImg from "../images/Construction.jpg";
import interiorImg from "../images/Interior.jpg";
import architectsImg from "../images/Architects.jpg";
import vastuImg from "../images/vastu.jpg";
import pujaImg from "../images/puja.jpg";
import Header from "../Layout/Header/header";
import Footer from "../Layout/Footer/footer";
import { motion } from 'framer-motion';
import EmailIcon from '@mui/icons-material/Email';

import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import { API_CONFIG } from '../api/apiUrl';

const contentVariants = {
    initial: { opacity: 0, y: 20 },
    in: { opacity: 1, y: 0 },
    out: { opacity: 0, y: -20 },
};

const contentTransition = {
    type: 'spring',
    stiffness: 120,
    damping: 20,
    duration: 0.3,
};

const Service = () => {
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const isFormValid = email && !emailError;

    const validateEmail = (value: any) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!value) {
            return 'Email is required';
        } else if (!emailRegex.test(value)) {
            return 'Please enter a valid email';
        }
        return '';
    };

    const handleEmailChange = (e: any) => {
        const value = e.target.value;
        setEmail(value);
        setEmailError(validateEmail(value));
    };

    const handleSubscribe = async (e: any) => {
        e.preventDefault();
        const error = validateEmail(email);
        if (error) {
            toast.error(error);
            setEmailError(error);
            return;
        }
        setIsLoading(true);
        try {
            const response = await axios.post(API_CONFIG.SUBSCRIBE_EMAILS, { email }, {
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.status === 200 || response.status === 201) {
                setEmail('');
                setEmailError('');
                toast.success('Submit successfully!');
            }
        } catch (error: any) {
            toast.error('Failed to subscribe');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Toaster position="top-right" />
            <Box sx={{ maxWidth: '2000px', margin: '0 auto' }}>
                <Header />
                <Box sx={{ flex: 1 }}>
                    <motion.div
                        variants={contentVariants}
                        initial="initial"
                        animate="in"
                        exit="out"
                        transition={contentTransition}
                    >
                        <Box sx={{ py: { xs: 2, sm: 3, md: 3, lg: 3, xl: 3 }, px: { xs: 2, md: 6.4 } }}>

                            <Grid container spacing={{ xs: 3, md: 0 }} alignItems="center">
                                <Grid item xs={12} md={7}>
                                    <Box>
                                        <Typography sx={{ fontWeight: 700, color: '#333333', fontSize: { xs: '22px', md: '32px' } }}>
                                            Construction/Civil Works
                                        </Typography>
                                        <ul className='service-ul-font-size' style={{
                                            paddingLeft: '20px', marginTop: '20px', fontSize: '16px', fontWeight: 400, lineHeight: '28px',
                                            fontFamily: 'Roboto'
                                        }}>
                                            <li>End-to-end construction solutions for residential and commercial projects.</li>
                                            <li>Project management, site supervision, and quality assurance.</li>
                                            <li>Expertise in civil works, structural engineering, and finishing.</li>
                                            <li>On-time delivery with transparent processes and cost control.</li>
                                        </ul>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <Paper elevation={0} sx={{ borderRadius: 4, overflow: 'hidden', height: { xs: 300, md: 318 } }}>
                                        <img src={constructionImg} alt='Construction Services' style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
                                    </Paper>
                                </Grid>
                            </Grid>

                            <Grid container spacing={{ xs: 3, md: 0 }} style={{ marginTop: '20px', marginBottom: '20px' }} alignItems="center">
                                <Grid item xs={12} md={5}>
                                    <Paper elevation={0} sx={{ borderRadius: 4, overflow: 'hidden', height: { xs: 300, md: 318 } }}>
                                        <img src={interiorImg} alt='Interior Works' style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={1}></Grid>
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <Typography sx={{ fontWeight: 700, color: '#161717', fontSize: { xs: '22px', md: '32px' } }}>
                                            Interior Works
                                        </Typography>
                                        <ul className='service-ul-font-size' style={{
                                            paddingLeft: '20px', marginTop: '20px', fontSize: '16px', fontWeight: 400, lineHeight: '28px',
                                            fontFamily: 'Roboto'
                                        }}>
                                            <li>Creative and functional interior design concepts for homes and offices.</li>
                                            <li>Space planning, modular furniture, and custom decor solutions.</li>
                                            <li>Turnkey interior execution with skilled craftsmen and premium materials.</li>
                                            <li>Personalized approach to reflect your style and needs.</li>
                                        </ul>
                                    </Box>
                                </Grid>
                            </Grid>

                            <Grid container spacing={{ xs: 3, md: 0 }} alignItems="center">
                                <Grid item xs={12} md={7}>
                                    <Box>
                                        <Typography sx={{ fontWeight: 700, color: '#161717', fontSize: { xs: '22px', md: '32px' } }}>
                                            Architects
                                        </Typography>
                                        <ul className='service-ul-font-size' style={{
                                            paddingLeft: '20px', marginTop: '20px', fontSize: '16px', fontWeight: 400, lineHeight: '28px',
                                            fontFamily: 'Roboto'
                                        }}>
                                            <li>Innovative architectural designs tailored to your vision and requirements.</li>
                                            <li>Comprehensive planning, 3D modeling, and blueprint development.</li>
                                            <li>Focus on sustainability, aesthetics, and regulatory compliance.</li>
                                            <li>Collaboration with engineers and contractors for seamless execution.</li>
                                        </ul>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <Paper elevation={0} sx={{ borderRadius: 4, overflow: 'hidden', height: { xs: 300, md: 318 } }}>
                                        <img src={architectsImg} alt='Architectural Services' style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
                                    </Paper>
                                </Grid>
                            </Grid>

                            <Grid container spacing={{ xs: 3, md: 0 }} style={{ marginTop: '20px', marginBottom: '20px' }} alignItems="center">
                                <Grid item xs={12} md={5}>
                                    <Paper elevation={0} sx={{ borderRadius: 4, overflow: 'hidden', height: { xs: 300, md: 318 } }}>
                                        <img src={vastuImg} alt='Vaastu Guidance' style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={1}></Grid>
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <Typography sx={{ fontWeight: 700, color: '#161717', fontSize: { xs: '22px', md: '32px' } }}>
                                            Vaastu Guidance
                                        </Typography>
                                        <ul className='service-ul-font-size' style={{
                                            paddingLeft: '20px', marginTop: '20px', fontSize: '16px', fontWeight: 400, lineHeight: '28px',
                                            fontFamily: 'Roboto'
                                        }}>
                                            <li>Expert consultation for Vaastu-compliant home and office spaces.</li>
                                            <li>Site analysis and recommendations for positive energy flow.</li>
                                            <li>Remedial solutions for existing structures without major alterations.</li>
                                            <li>Personalized guidance for prosperity, health, and harmony.</li>
                                        </ul>
                                    </Box>
                                </Grid>
                            </Grid>

                            <Grid container spacing={{ xs: 3, md: 0 }} alignItems="center">
                                <Grid item xs={12} md={7}>
                                    <Box>
                                        <Typography sx={{ fontWeight: 700, color: '#161717', fontSize: { xs: '22px', md: '32px' } }}>
                                            Pooja/Ceremonies Services
                                        </Typography>
                                        <ul className='service-ul-font-size' style={{
                                            paddingLeft: '20px', marginTop: '20px', fontSize: '16px', fontWeight: 400, lineHeight: '28px',
                                            fontFamily: 'Roboto'
                                        }}>
                                            <li>Arrangement of traditional pooja and religious ceremonies by experienced priests.</li>
                                            <li>Customized rituals for housewarming, weddings, festivals, and special occasions.</li>
                                            <li>Provision of all required materials and decor for ceremonies.</li>
                                            <li>End-to-end support for a spiritual and memorable experience.</li>
                                        </ul>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <Paper elevation={0} sx={{ borderRadius: 4, overflow: 'hidden', height: { xs: 300, md: 318 } }}>
                                        <img src={pujaImg} alt='Pooja Services' style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
                                    </Paper>
                                </Grid>
                            </Grid>


                            <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                px={0}
                                pt={5}
                            >
                                <Typography sx={{
                                    fontWeight: 700,
                                    fontSize: { xs: '30px', md: '45px' }
                                }}>
                                    Need any other Service?
                                </Typography>
                                <Typography sx={{
                                    fontWeight: 400,
                                    fontSize: { xs: '15px', md: '18px' }
                                }} align="center" mb={2}>
                                    Share your email and we will reach back. <br />
                                    You can also check the Contact Us page.
                                </Typography>
                                <Box component="form" onSubmit={handleSubscribe} sx={{ display: 'flex' }}>
                                    <TextField
                                        fullWidth
                                        placeholder="Enter Your Email"
                                        variant="outlined"
                                        size="medium"
                                        value={email}
                                        onChange={handleEmailChange}
                                        error={!!emailError}
                                        helperText={emailError}
                                        InputProps={{
                                            startAdornment: <EmailIcon sx={{ mr: 1, color: '#89652A' }} />
                                        }}
                                        sx={{
                                            borderRadius: '10px',
                                            '& .MuiOutlinedInput-root': {
                                                fontSize: '18px',
                                                borderRadius: '12px',
                                                borderColor: '#89652A',
                                                '& .MuiOutlinedInput-notchedOutline': { borderColor: '#B69D74', borderWidth: '1.5px' },
                                                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#89652A' },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#89652A', borderWidth: '2px' },
                                            },
                                            '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#B69D74',
                                            },
                                            '& .MuiInputBase-input': { padding: '14px 14px' },
                                            '& .MuiFormHelperText-root': {
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                margin: 0,
                                                fontSize: '12px',
                                                color: 'error.main'
                                            }
                                        }}
                                    />
                                    <Button
                                        type="submit"
                                        sx={{
                                            ml: 2,
                                            bgcolor: '#89652A',
                                            fontSize: '20px',
                                            fontWeight: 600,
                                            padding: "0px 40px",
                                            fontFamily: "League Spartan",
                                            textTransform: 'capitalize',
                                            borderRadius: '6px',
                                            color: 'white',
                                            '&:hover': { bgcolor: '#6b4e20' },
                                            '&:disabled': { bgcolor: '#a88b5e' }
                                        }}
                                        disabled={!isFormValid || isLoading}
                                    >
                                        {isLoading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : 'Submit'}
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    </motion.div>
                </Box>
                <Footer />
            </Box>
        </>
    );
};

export default Service;